import React from 'react';

import Step from 'components/stepper/Step';
import SingleFormPage from 'components/form/SingleFormPage';
import mapStepToInput from 'components/recipes/steps/mapStepToInput';
import RecipeValidator from 'domain/recipe/usecases/validator';

import mapStepToDescription from './mapStepToDescription';

const SinglePageFormStep = ({
  step,
  pageTitle,
  recipe,
  setRecipe,
  goToNextStep,
  goToPreviousStep,
}) => {
  return (
    <Step
      key={step}
      onBackButtonClick={goToPreviousStep}
      stepTitle={pageTitle}
      spacing={8}
      renderBody={() => {
        return (
          <SingleFormPage
            submitButtonLabel="NEXT"
            Input={mapStepToInput(step)}
            inputValue={recipe[step]}
            onInputChange={(value) => setRecipe({ ...recipe, [step]: value })}
            validator={RecipeValidator[step]}
            onInputSubmit={goToNextStep}
          ></SingleFormPage>
        );
      }}
      renderDescription={() => {
        const Description = mapStepToDescription(step);
        return <Description></Description>;
      }}
    ></Step>
  );
};

export default SinglePageFormStep;
